import React from 'react'

const NotFoundGeneral = () => {
    return (
        <div className="main-four-oh-four-container">
            <div className="sportsnet-logo-left">
                <img
                    src="https://www.sportsnet.ca/wp-content/themes/sportsnet-nhl/images/sportsnet-dark.svg"
                    alt="sn logo"
                />
            </div>
            <div className="four-oh-four-content-right">
                <h1 className="h1-error-copy">
                    Whoops! We&#39;re having trouble finding the page you&#39;re looking for.
                </h1>
                <h2 className="h2-error-copy">
                    Don&#39;t worry, we&#39;ll get you back on track in no time.
                </h2>
                <span className="error-copy">
                    <ul className="error-bullets">
                        <li>If you typed in the address, be sure to double check the spelling.</li>
                        <li>
                            If you believe you&#39;ve found a technical error, please{' '}
                            <a href="https://www.sportsnet.ca/contact-us/">contact us</a> and let us
                            know.
                        </li>
                        <li>If you&#39;ve followed a link to get here, it could be broken.</li>
                    </ul>
                </span>
                <span className="error-bottom-copy">
                    It might be best to start back at our{' '}
                    <a href="https://www.sportsnet.ca">Sportsnet.ca home page</a>.
                </span>
            </div>
        </div>
    )
}

export default NotFoundGeneral
